import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// import translationGr from "./locales/gr.json";
// import translationIT from "./locales/it.json";
// import translationRS from "./locales/ru.json";
// import translationSP from "./locales/sp.json";
import translationENG from './locales/en.json';
// import translationFR from "./locales/fr.json";
// import translationAR from "./locales/ar.json";
import translationTH from './locales/th.json';
import translationZH from './locales/zh.json';
import translationMY from './locales/my.json';
import translationLO from './locales/lo.json';
import { getLanguageCookie } from 'utils/common/languageCookie';

// the translations
const resources = {
  // gr: {
  //   translation: translationGr,
  // },
  // it: {
  //   translation: translationIT,
  // },
  // rs: {
  //   translation: translationRS,
  // },
  // sp: {
  //   translation: translationSP,
  // },
  en: {
    translation: translationENG,
  },
  // fr: {
  //   translation: translationFR,
  // },
  // ar: {
  //   translation: translationAR,
  // },
  th: {
    translation: translationTH,
  },
  zh: {
    translation: translationZH,
  },
  my: {
    translation: translationMY,
  },
  lo: {
    translation: translationLO,
  },
};

// The shared cookie wins so a language picked in the PHP system carries over.
const language =
  getLanguageCookie() || localStorage.getItem('I18N_LANGUAGE') || 'en';
localStorage.setItem('I18N_LANGUAGE', language);

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: language,
    fallbackLng: 'en', // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
